import { render } from "./Rating.vue?vue&type=template&id=5a457706"
import script from "./Rating.vue?vue&type=script&setup=true&lang=js"
export * from "./Rating.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Pages/Retours/Table/Fields/Rating.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a457706"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a457706', __exports__)) {
    api.reload('5a457706', __exports__)
  }
  
  module.hot.accept("./Rating.vue?vue&type=template&id=5a457706", () => {
    api.rerender('5a457706', render)
  })

}


export default __exports__